import React from 'react'
import moment from "moment";
import style from './ExamResult.module.css';

const SolutionTPT = ({ exam, TPTSolution }) => {
    const midIndex = Math.ceil(TPTSolution.length / 2);
    const leftQuestions = TPTSolution.slice(0, midIndex);
    const rightQuestions = TPTSolution.slice(midIndex);

    const chunked = [];
    for (let i = 0; i < TPTSolution.length; i += 20) {
        chunked.push(TPTSolution.slice(i, i + 20));
    }

    return (
        <div>
            <div className='row' style={{ border: '1px solid black', display: 'flex', alignItems: 'center' }}>
                <div className='col-4 d-flex justify-content-center'>
                    <img src='/assets/images/monoarclogo2.jpeg' width='95%' alt='logo' className='my-3' />
                </div>
                <div
                    className='col-5 d-flex flex-column justify-content-center text-center'
                    style={{ borderRight: '1px solid black', borderLeft: '1px solid black', alignSelf: 'stretch', }}
                >
                    <h3 className='fw-bold'>{exam.courseName}</h3>
                </div>
                <div className='col-3 d-flex flex-column justify-content-center fw-bold'>
                    <span>NEET UG</span>
                    <span>{exam.className}</span>
                    <span>Date : {moment(exam.startDate).format('DD MMMM YYYY')}</span>
                </div>
            </div>
            <div className='row'>
                <h4 className="text-center py-1 fw-bold" style={{ borderBottom: '1px solid black' }}>{exam.examName}</h4>
                <h4 className="text-center fw-bold">Answer Key</h4>
            </div>
            <div className='row'>
                <table
                    style={{
                        borderCollapse: 'collapse',
                        tableLayout: 'auto',
                        borderSpacing: 0
                    }}
                >
                    <tbody>
                        {chunked.map((chunk, idx) => (
                            <React.Fragment key={idx}>
                                <tr>
                                    <td className='aq-key' style={{ backgroundColor: '#f0f0f0', border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                                        Q.
                                    </td>
                                    {chunk.map((q,i) => (
                                        <td
                                            key={`q-${i+1}`}
                                            className='aq-key'
                                            style={{ backgroundColor: '#f0f0f0', border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {i+1}
                                        </td>
                                    ))}
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                                        A.
                                    </td>
                                    {chunk.map((q,i) => (
                                        <td
                                            key={`a-${i+1}`}
                                            style={{ border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {q.correct}
                                        </td>
                                    ))}
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
                <h4 className='text-center fw-bold' style={{ borderBottom: '1px solid black' }}>Solutions</h4>
            </div>
            <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black' }}>
                {TPTSolution.map((q, i) => (
                    <div key={i} className={`px-1 question ${style.questionPaper}`}>
                        <div className="d-flex"
                            dangerouslySetInnerHTML={{
                                __html: `<span class='mr-2 fw-bold fs-6'>${i + 1}.</span>&nbsp;&nbsp;<span>
                                <b>Option ( ${q.correct} )</b><br>${q.solution}</span>`,
                            }}
                        >
                        </div>
                    </div>
                ))}
            </div>
            {/* <div className="d-flex">
                <div className='w-50 pr-2' style={{ borderRight: '1px solid black' }}>
                    <div>
                        {leftQuestions.map((q, i) => (
                            <div key={i} className={`mb-2 ${style.questionPaper}`}>
                                <div className="mb-2 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>${i + 1}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                    }}
                                >
                                </div>
                                <span key={i} className="mx-3 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span>${q.solution}</span>`
                                    }}
                                >
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w-50 pl-3">
                    <div>
                        {rightQuestions.map((q, i) => (
                            <div key={i} className={`mb-2 ${style.questionPaper}`}>
                                <div className="mb-2 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span class='mr-2 fw-bold fs-6'>&nbsp;&nbsp;${midIndex + i + 1}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                                    }}
                                >
                                </div>
                                <span key={i} className="mx-3 d-flex"
                                    dangerouslySetInnerHTML={{
                                        __html: `<span>${q.solution}</span>`
                                    }}
                                >
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default SolutionTPT
